<template>
  <modal class="root" ref="confirmBankInformation">
    <template slot="header">
      <div class="margin-bottom-30 width-100">
        <h3 class="modal-title text-center hh-danger margin-bottom-20">WARNING</h3>
        <p class="text-left warning-info">
          You are about to change your receiver's bank account information.
        </p>
      </div>
    </template>

    <template slot="body">
      <div class="panel-body">
        <p class="modal-text">
          Changing any of the account information will also change it for all
          of your existing campaigns.
        </p>
        <p class="modal-text" v-if="userCampaigns && Object.keys(userCampaigns).length !== 0">
          This account information is being used by the following campaigns:
        </p>
        <ul v-for="campaign in userCampaigns">
          <li>{{ campaign }}</li>
        </ul>
      </div>
    </template>

    <template slot="footer">
      <form class="form" ref="form" @submit.prevent="submit">
        <div class="margin-top-20 margin-bottom-30 width-100">
          <div class="row margin-bottom-20">
            <div class="form-group col-sm-12">
              <div class="hh-checkbox">
                <input
                    id="accept_edit"
                    type="checkbox"
                    v-model="modalData.accept_edit"
                    required
                />
                <label
                    for="accept_edit"
                    class="margin-left-10 is-for-business"
                >
                  I understand and wish to proceed
                </label>
              </div>
              <div>
                <div class="invalid-feedback-red" v-if="modalData.hasError">
                  You must agree before proceeding.
                </div>
              </div>
            </div>
          </div>
          <div class="row modal-footer-wrapper">
            <div class="col-sm-6 margin-bottom-20">
              <button name="Close"
                  type="button"
                  class="btn hh-btn hh-back-btn save-btn width-100"
                  @click="closeModal"
              >
                Close
              </button>
            </div>
            <div class="col-sm-6">
              <button name="Continue to edit"
                  type="submit"
                  class="btn save-btn hh-btn-green"
              >
                Continue to edit
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import Modal from '../form/elements/Modal'

export default {
  name: "ConfirmBankInformationModal",

  components: {
    Modal,
  },

  props: {
    userCampaigns: Object,
  },

  data() {
    return {
      modalData: {
        accept_edit: null,
        hasError: null,
      },
    }
  },

  mounted() {

  },

  methods: {
    openModal() {
      this.$refs.confirmBankInformation.openModal()
    },

    closeModal() {
      this.$refs.confirmBankInformation.closeModal()
    },

    submit() {
      if (!this.modalData.accept_edit) {
        this.modalData.hasError = true
        return false
      }

      this.complete()
    },

    complete() {
      this.$emit('complete')
      this.$refs.confirmBankInformation.closeModal()
    },
  },

  computed: {}
}
</script>

<style lang="scss" scoped>
.root::v-deep {
  @import '../../../style/pages/register';

  .hh-modal-dialog {
    padding: 0 30px;

    @media (max-width: $screen-sm-max) {
      padding: 15px;

      .hh-modal-header {
        padding: 0;
      }

      .hh-modal-body {
        padding: 0;
      }

      .hh-modal-footer {
        padding: 0;
      }
    }

    .panel-body {
      padding: 0;
    }

    .close-btn-wrapper {
      margin-right: 0;
    }
  }

  .hh-modal-dialog {
    border: 8px solid #ea641e;
    box-sizing: border-box;
    border-radius: 8px;
  }

  .hh-danger {
    color: #ea641e;
  }

  .invalid-feedback-red {
    display: block;
    color: rgb(188, 46, 46);
  }

  .warning-info {
    font-size: 20px;
    line-height: 25px;
    color: #3e3e3e;
  }

  .modal-text {
    font-size: 18px;
    line-height: 23px;

    color: #3e3e3e;
  }

  .hh-back-btn {
    border: 2px solid rgb(29, 192, 113);
    color: rgb(29, 192, 113);
    background: white;
    font-weight: 500;
    font-size: 16px;
    line-height: 16px;
    text-align: center;
  }
}
</style>